import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { UserManagementComponent } from './user-management.component';
import { ManageDocumentsComponent } from './manage-documents/manage-documents.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AddUserComponent } from './add-user/add-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { UpdatePictureComponent } from './update-picture/update-picture.component';
import { CreateAggressorComponent } from './view-user/create-agressor/create-agressor.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: UserManagementComponent,
                canActivate: [AuthGuard]
            }, {
                path: 'manageDocuments/:id',
                data: {
                    breadcrumb: 'manageDocuments'
                },
                children: [
                    {
                        path: '',
                        component: ManageDocumentsComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            },{
                path: 'add-user',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'add-user'
                },
                children: [
                    {
                        path: '',
                        component: AddUserComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            },{
                path: 'edit-user/:id',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'edit-user'
                },
                children: [
                    {
                        path: '',
                        component: EditUserComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            },{
                path: 'view-user/:id',
                data: {
                    breadcrumb: 'view-user'
                },
                children: [
                    {
                        path: '',
                        component: ViewUserComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            },{
                path: 'view-user/:id/aggressor',
                data: {
                    breadcrumb: 'aggressor-management'
                },
                children: [
                    {
                        path: '',
                        component: CreateAggressorComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            },
            {
                path: 'view-user/:id/:aggressorId',
                data: {
                    breadcrumb: 'aggressor-management'
                },
                children: [
                    {
                        path: '',
                        component: CreateAggressorComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            },
            {
                path: 'edit-user-picture/:id/:photo',
                canActivate: [AuthGuard],
                data: {
                    breadcrumb: 'editPicture'
                },
                children: [
                    {
                        path: '',
                        component: UpdatePictureComponent,
                        canActivate: [AuthGuard]
                    }
                ]
            }

        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UserManagementRoutingModule { }
